import { api } from "../../services/api"

const timeoutMap = new Map();

const timeoutList = (v, endpoint, field, label, setState, value = false) => {
    const key = `${endpoint}-${field}`; // Unique key per endpoint+field

    if (timeoutMap.has(key)) {
        clearTimeout(timeoutMap.get(key));
    }

    const newTimeout = setTimeout(() => {
        getItemList(v, endpoint, field, label, setState, value);
        timeoutMap.delete(key); // Optional cleanup
    }, 500);

    timeoutMap.set(key, newTimeout);
};

const getItemList =async (v, endpoint, field, label, setState, value=false) => {
    setState({smallLoading: true})
    const res = await api.post(endpoint, {search: v}, {timeout: 10000})
    const result = {smallLoading: false}
    if (res.status === 200){
        result[field] = res.data.map((e) => ({label: e[label], id: e.id, ...(value ? {value:e.value} : {}) ,data: e}))
    }
    setState(result)
}

export default timeoutList 